// extracted by mini-css-extract-plugin
module.exports = {"link":"_27d19","image":"xuAq5","PaperclipPhoto":"_1eQEK","paperclipPhoto":"_1eQEK","wrp":"_2mDwp","xxx":"_2IW2i","clip":"_1ExbE"};